/* unplugin-vue-components disabled */import { render } from "./QuizViewerCarousel.vue?vue&type=template&id=646606ee&ts=true"
import script from "./QuizViewerCarousel.vue?vue&type=script&lang=ts"
export * from "./QuizViewerCarousel.vue?vue&type=script&lang=ts"

import "./QuizViewerCarousel.vue?vue&type=style&index=0&id=646606ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__